import { render, staticRenderFns } from "./RagioneriaPortinerieView.vue?vue&type=template&id=1e3e32b9&"
import script from "./RagioneriaPortinerieView.vue?vue&type=script&lang=ts&"
export * from "./RagioneriaPortinerieView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports